const PLACEHOLDER_SOURCE = /\/assets\/placeholder\//i;

/** Nie pokazuj placeholdera jako kotka tylko dlatego, że klucz tekstury istnieje. */
export function isUsableCompanionTexture(
  exists: boolean,
  sourceUrl?: string,
): boolean {
  if (!exists) return false;
  if (!sourceUrl) return true;
  return !PLACEHOLDER_SOURCE.test(sourceUrl);
}

/**
 * Prefer the decoded texture URL over registry `assetSource:*`.
 * A stale registry placeholder must not veto a real cat loaded in preload().
 */
export function pickCompanionSourceUrl(
  decodedSrc?: string,
  registrySource?: string,
): string | undefined {
  const decoded = decodedSrc?.trim();
  if (decoded) return decoded;
  const reg = registrySource?.trim();
  return reg || undefined;
}

/** Pure pose key for Image-based companion sprite animation. */
export function catPoseTextureKey(walking: boolean, walkFrameB: boolean): string {
  if (!walking) return 'cat_idle';
  return walkFrameB ? 'cat_walkB' : 'cat_walkA';
}
